import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import Link from './Link.js';
import styles from './ArticleTitle.module.css';
import TopRssArticleLink from './TopRssArticleLink.js';
import urlJoinParameters from '../utils/urlJoinParameters.js';

const ArticleTitleRssFeed = () => {
  const {
    tpcc,
    __source,
    articleLink,
    articleTitle,
    articleTitleTextAlign: textAlign,
    articleTitleFontWeight: fontWeight,
  } = useSearchParamOrDefaultProps();

  const style = {
    textAlign,
    fontWeight,
  };

  const shouldOverrideRSSArticleLink =
    articleTitle.length && articleLink.length;

  const to = urlJoinParameters(articleLink, { __source, tpcc });

  return (
    <article className={styles.articleTitleWrapper}>
      <div className={styles.articleTitle} style={style}>
        {shouldOverrideRSSArticleLink ? (
          <Link to={to}>{articleTitle}</Link>
        ) : (
          <TopRssArticleLink />
        )}
      </div>
    </article>
  );
};

ArticleTitleRssFeed.displayName = 'ArticleTitleRssFeed';

export default ArticleTitleRssFeed;
